import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaOr_1.mjs'
import FormChoose from './FormChooseOr_1.jsx'
import TableChoose from './TableChooseOr_1.jsx'
import api from './apiOr_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
